/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/no-unnamed-components */

'use es6';

import { Switch, Redirect, Route } from 'react-router-dom';
import NotFoundPagePortal from 'ContentEditorUI/components/app/NotFoundPagePortal';
import UniversalApplicationContainer from 'ContentEditorUI/containers/UniversalApplicationContainer';
import ContentViewContainer from 'page-editor-ui/containers/views/ContentViewContainer';
import PagePreviewRouteContainer from 'page-editor-ui/containers/PagePreviewRouteContainer';
import BaymaxRevisionsModalContainer from 'ContentEditorUI/containers/BaymaxRevisionsModalContainer';
import Routes from 'ContentUtils/Routes';
import { gate } from 'hub-http/gates';
import PageThemeRevisionsModalContainer from 'page-editor-ui/containers/PageThemeRevisionsModalContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PRIMARY_ROUTE = '/:contentId';
const SIMPLE_ROUTE_NAME_FOR_NEWRELIC = ':contentId';
const concatPaths = (path, endRoutePath) => `${path}/${endRoutePath}`;
const routeWithSubViews = path => {
  return /*#__PURE__*/_jsx(Route, {
    path: path,
    name: SIMPLE_ROUTE_NAME_FOR_NEWRELIC,
    children: /*#__PURE__*/_jsx(UniversalApplicationContainer, {
      children: /*#__PURE__*/_jsxs(Switch, {
        children: [/*#__PURE__*/_jsx(Route, {
          exact: true,
          path: concatPaths(path, 'content'),
          component: ContentViewContainer
        }), /*#__PURE__*/_jsx(Route, {
          exact: true,
          path: concatPaths(path, 'revisions'),
          component: Routes.isUngated(gate('UniversalThemeEditor')) ? PageThemeRevisionsModalContainer : BaymaxRevisionsModalContainer
        }), /*#__PURE__*/_jsx(Route, {
          exact: true,
          path: concatPaths(path, 'optimize'),
          component: ContentViewContainer
        }), /*#__PURE__*/_jsx(Route, {
          exact: true,
          path: concatPaths(path, 'settings'),
          component: ContentViewContainer
        }), /*#__PURE__*/_jsx(Route, {
          exact: true,
          path: concatPaths(path, 'preview'),
          component: PagePreviewRouteContainer
        }), /*#__PURE__*/_jsx(Route, {
          exact: true,
          path: concatPaths(path, 'test'),
          component: ContentViewContainer
        }), /*#__PURE__*/_jsx(Redirect, {
          to: Object.assign({}, window.location, {
            pathname: concatPaths(path, 'content')
          })
        })]
      })
    })
  });
};
export default (() => {
  return /*#__PURE__*/_jsxs(Switch, {
    children: [routeWithSubViews(PRIMARY_ROUTE), /*#__PURE__*/_jsx(Route, {
      path: "*",
      component: NotFoundPagePortal
    })]
  });
});